(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pronat-performance-composer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initComposer = (root) => {
      if (!root || root.dataset.ppBound === 'true') return;
      root.dataset.ppBound = 'true';

      root.querySelectorAll('[data-pp-finder]').forEach((finder) => {
        const buttons = [...finder.querySelectorAll('[data-pp-finder-filter]')];
        const items = [...finder.querySelectorAll('[data-pp-finder-item]')];
        const count = finder.querySelector('[data-pp-finder-count]');
        const empty = finder.querySelector('[data-pp-finder-empty]');

        const applyFilter = (filter) => {
          let visible = 0;
          items.forEach((item) => {
            const tags = (item.dataset.ppTags || '').split('||');
            const matches = filter === 'all' || tags.includes(filter);
            item.hidden = !matches;
            if (matches) visible += 1;
          });
          buttons.forEach((button) => {
            const isActive = button.dataset.ppFinderFilter === filter;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });
          if (count) count.textContent = `${visible} produse afișate`;
          if (empty) empty.hidden = visible !== 0;
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const update = () => applyFilter(button.dataset.ppFinderFilter || 'all');
            if (typeof document.startViewTransition === 'function') {
              document.startViewTransition(update);
            } else {
              update();
            }
          });
        });
        applyFilter('all');
      });

      root.querySelectorAll('[data-pp-sticky-form]').forEach((form) => {
        const select = form.querySelector('[data-pp-sticky-variant]');
        const price = form.querySelector('[data-pp-sticky-price]');
        const button = form.querySelector('[data-pp-sticky-button]');
        if (!select) return;
        const updateVariant = () => {
          const option = select.options[select.selectedIndex];
          if (price) price.textContent = option.dataset.price || '';
          if (button) button.disabled = option.dataset.available !== 'true';
        };
        select.addEventListener('change', updateVariant);
        updateVariant();
      });
    };

    const boot = () => document.querySelectorAll('[data-pp-composer]').forEach(initComposer);

    if (!window.PronatPerformanceComposer) {
      window.PronatPerformanceComposer = { boot };
      document.addEventListener('shopify:section:load', (event) => {
        const root = event.target.matches('[data-pp-composer]') ? event.target : event.target.querySelector('[data-pp-composer]');
        initComposer(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pronat-vurcher-b2b"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeVurcherB2B = () => {
    document.querySelectorAll('[data-vp-b2b-section]').forEach((section) => {
      if (section.dataset.vpB2bReady === 'true') return;
      section.dataset.vpB2bReady = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.querySelectorAll('[data-vp-b2b-scroll]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;
          const target = document.getElementById(href.slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => {
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }, reducedMotion ? 0 : 350);
        });
      });

      if (section.dataset.singleFaq === 'true') {
        const items = [...section.querySelectorAll('[data-vp-b2b-faq]')];
        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            items.forEach((otherItem) => {
              if (otherItem !== item) otherItem.open = false;
            });
          });
        });
      }

      const successMessage = section.querySelector('[data-vp-b2b-success]');
      if (successMessage) window.requestAnimationFrame(() => successMessage.focus());
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVurcherB2B, { once: true });
  } else {
    initializeVurcherB2B();
  }

  document.addEventListener('shopify:section:load', initializeVurcherB2B);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
